import { createModel, trackFunction } from 'ibiza'
import { compact } from 'lodash'

import fetch from 'assets/lib/utils/fetch'

export default createModel('/bookmarks', items => ({
  items: items.map(item => item.therapistId),

  get hasBookmarks() {
    return this.items.length > 0
  },

  isBookmarked: trackFunction(function (_, therapistId) {
    return this.items.includes(therapistId)
  }),

  // Toggle bookmark for the given `therapistId` in a fire and forget manner. This allows us to
  // change the UI without needing to show any loading state. If the server request fails, then
  // the change is reverted.
  toggle(_, therapistId) {
    if (this.items.includes(therapistId)) {
      this.remove(therapistId)

      return fetch(`/bookmarks/${therapistId}`, { method: 'delete', handleError: false }).catch(
        error => {
          // Revert on error
          this.add(therapistId)

          throw error
        }
      )
    } else {
      this.add(therapistId)

      return fetch('/bookmarks', {
        method: 'post',
        handleError: false,
        body: { bookmark: { therapistId } }
      }).catch(error => {
        // Revert on error
        this.remove(therapistId)

        throw error
      })
    }
  },

  remove(_, therapistId) {
    delete this.items[this.items.indexOf(therapistId)]
    this.items = compact(this.items)
  },

  add(_, therapistId) {
    this.items = this.items.concat([therapistId])
  }
}))
